import { useState, useEffect } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { Wrench, Menu, X, CalendarDays } from 'lucide-react'

const navLinks = [
  { label: 'Serviços', href: '#servicos' },
  { label: 'Como funciona', href: '#como-funciona' },
  { label: 'Sobre', href: '#sobre' },
  { label: 'Depoimentos', href: '#depoimentos' },
  { label: 'Contato', href: '#formulario' },
]

const Header = () => {
  const [scrolled, setScrolled] = useState(false)
  const [mobileOpen, setMobileOpen] = useState(false)

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30)
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  const handleNavClick = (e, href) => {
    e.preventDefault()
    setMobileOpen(false)
    const id = href.replace('#', '')
    const el = document.getElementById(id)
    if (el) el.scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <header
      data-testid="header"
      className={`fixed top-0 w-full z-50 transition-all duration-400 ${
        scrolled
          ? 'bg-white/98 backdrop-blur-xl shadow-[0_2px_20px_rgba(6,43,99,0.08)]'
          : 'bg-white/80 backdrop-blur-md'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 h-16 flex items-center justify-between">
        {/* Logo */}
        <a href="/" data-testid="header-logo" className="flex items-center gap-2.5 group">
          <div className="w-9 h-9 bg-[#062B63] flex items-center justify-center group-hover:bg-[#F2B300] transition-colors duration-300">
            <Wrench size={18} className="text-[#F2B300] group-hover:text-[#062B63] transition-colors duration-300" />
          </div>
          <div>
            <div className="text-[#062B63] font-bold text-[11px] leading-tight font-outfit tracking-[0.12em] uppercase">
              MARIDO DE ALUGUEL
            </div>
            <div className="text-[#062B63]/45 text-[9px] leading-tight tracking-[0.12em] uppercase font-inter">
              Reparos e Manutenção
            </div>
          </div>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-7" data-testid="desktop-nav">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={(e) => handleNavClick(e, link.href)}
              className="text-[13px] text-[#062B63]/65 hover:text-[#062B63] transition-colors font-medium tracking-wide relative group"
            >
              {link.label}
              <span className="absolute -bottom-0.5 left-0 w-0 h-px bg-[#F2B300] group-hover:w-full transition-all duration-300" />
            </a>
          ))}
        </nav>

        {/* Desktop CTA */}
        <a
          href="#formulario"
          onClick={(e) => handleNavClick(e, '#formulario')}
          data-testid="header-cta-btn"
          className="hidden md:flex items-center gap-2 bg-[#F2B300] text-[#062B63] px-5 py-2.5 text-[13px] font-bold hover:brightness-95 transition-all"
        >
          <CalendarDays size={15} />
          Solicitar orçamento
        </a>

        {/* Mobile hamburger */}
        <button
          data-testid="mobile-menu-btn"
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden p-2 text-[#062B63]"
          aria-label="Abrir menu de navegação"
        >
          {mobileOpen ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {mobileOpen && (
          <motion.div
            data-testid="mobile-menu"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.25 }}
            className="md:hidden bg-white border-t border-[#062B63]/8 overflow-hidden"
          >
            <div className="px-6 py-5 flex flex-col gap-1">
              {navLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  onClick={(e) => handleNavClick(e, link.href)}
                  className="text-[#062B63] font-medium py-3 border-b border-[#062B63]/6 text-sm"
                >
                  {link.label}
                </a>
              ))}
              <a
                href="#formulario"
                onClick={(e) => handleNavClick(e, '#formulario')}
                className="mt-3 flex items-center justify-center gap-2 bg-[#F2B300] text-[#062B63] px-5 py-3.5 text-sm font-bold"
              >
                <CalendarDays size={15} />
                Solicitar orçamento
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  )
}

export default Header
